import React from 'react';
export function TrustBadges() {
  return <div className="font-body max-w-[420px] mx-auto my-3 text-text-primary px-4 space-y-3" data-id="element-204">
      {/* Pago Seguro */}
      <fieldset className="border border-black/10 px-4 py-3 text-center bg-white rounded-2xl shadow-sm" data-id="element-205">
        <legend className="px-3 text-text-secondary text-sm flex items-center gap-1.5 mx-auto bg-white font-medium" data-id="element-206">
          <svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" data-id="element-207">
            <rect x="3" y="11" width="18" height="11" rx="2" ry="2" data-id="element-208"></rect>
            <path d="M7 11V7a5 5 0 0 1 10 0v4" data-id="element-209"></path>
          </svg>
          Pago seguro garantizado
        </legend>

        <div className="flex justify-center gap-8 items-center pt-2 pb-1" data-id="element-210">
          {/* VISA */}
          <div className="text-[#1A1F71] font-black italic text-2xl tracking-tight" style={{
          fontFamily: 'Arial, sans-serif'
        }} data-id="element-211">
            VISA
          </div>

          {/* Mastercard */}
          <div className="flex flex-col items-center" data-id="element-212">
            <svg viewBox="0 0 32 20" width="36" height="22" data-id="element-213">
              <circle cx="11" cy="10" r="10" fill="#EB001B" data-id="element-214" />
              <circle cx="21" cy="10" r="10" fill="#F79E1B" opacity="0.85" data-id="element-215" />
            </svg>
            <span className="text-[8px] text-text-secondary mt-0.5 font-medium" data-id="element-216">
              mastercard
            </span>
          </div>

          {/* PayPal */}
          <div className="text-[22px]" style={{
          fontFamily: 'Arial, sans-serif'
        }} data-id="element-217">
            <span className="text-[#003087] font-extrabold italic" data-id="element-218">Pay</span>
            <span className="text-[#009CDE] font-extrabold italic" data-id="element-219">Pal</span>
          </div>
        </div>
      </fieldset>

      {/* MercadoLíder Platinum */}
      <div className="bg-white rounded-2xl p-4 shadow-sm border border-black/10" data-id="element-220">
        <div className="flex items-start gap-3 mb-3" data-id="element-221">
          <div className="flex items-center justify-center mt-0.5" data-id="element-222">
            <svg xmlns="http://www.w3.org/2000/svg" width="28" height="28" viewBox="0 0 24 24" fill="none" stroke="#1A5C3A" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" data-id="element-223">
              <path d="M12 2l3.09 3.09L19.36 6l-.82 4.18L22 13.09l-3.27 2.55L18 20l-4.18-.82L10.73 22l-2.55-3.27L4 18l.82-4.18L2 10.91l3.27-2.55L6 4l4.18.82L13.09 2z" data-id="element-224"></path>
              <path d="M9 12l2 2 4-4" stroke="#1A5C3A" data-id="element-225"></path>
            </svg>
          </div>
          <div data-id="element-226">
            <h3 className="m-0 text-primary text-lg font-bold leading-tight" data-id="element-227">
              MercadoLíder Platinum
            </h3>
            <p className="m-0 mt-0.5 text-text-secondary text-sm" data-id="element-228">
              ¡Uno de los mejores del sitio!
            </p>
          </div>
        </div>

        {/* Colorful Progress Bar */}
        <div className="flex h-1.5 gap-1 mb-3 rounded-full overflow-hidden" data-id="element-229">
          <span className="flex-1 rounded-full bg-red-400" data-id="element-230"></span>
          <span className="flex-1 rounded-full bg-orange-300" data-id="element-231"></span>
          <span className="flex-1 rounded-full bg-yellow-300" data-id="element-232"></span>
          <span className="flex-1 rounded-full bg-green-300" data-id="element-233"></span>
          <span className="flex-1 rounded-full bg-primary" data-id="element-234"></span>
        </div>

        {/* Stats */}
        <div className="flex justify-between text-center" data-id="element-235">
          <div className="flex flex-col items-center flex-1" data-id="element-236">
            <strong className="text-text-primary text-base font-bold mb-0.5 leading-tight" data-id="element-237">
              +10mil
            </strong>
            <span className="text-xs text-text-secondary" data-id="element-238">Ventas</span>
          </div>

          <div className="flex flex-col items-center flex-1" data-id="element-239">
            <div className="h-6 flex items-center mb-0.5" data-id="element-240">
              <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="#888" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" data-id="element-241">
                <path d="M21 11.5a8.38 8.38 0 0 1-.9 3.8 8.5 8.5 0 0 1-7.6 4.7 8.38 8.38 0 0 1-3.8-.9L3 21l1.9-5.7a8.38 8.38 0 0 1-.9-3.8 8.5 8.5 0 0 1 4.7-7.6 8.38 8.38 0 0 1 3.8-.9h.5a8.48 8.48 0 0 1 8 8v.5z" data-id="element-242"></path>
                <path d="M15 10l-4 4-2-2" stroke="#1A5C3A" strokeWidth="2" data-id="element-243"></path>
              </svg>
            </div>
            <span className="text-xs text-text-secondary" data-id="element-244">Buena atención</span>
          </div>

          <div className="flex flex-col items-center flex-1" data-id="element-245">
            <div className="h-6 flex items-center mb-0.5" data-id="element-246">
              <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="#888" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" data-id="element-247">
                <circle cx="12" cy="12" r="10" data-id="element-248"></circle>
                <path d="M12 6v6l2 1" data-id="element-249"></path>
                <circle cx="18" cy="18" r="5" fill="#fff" stroke="#fff" data-id="element-250"></circle>
                <path d="M16 18l1.5 1.5 2.5-2.5" stroke="#1A5C3A" strokeWidth="2" data-id="element-251"></path>
              </svg>
            </div>
            <span className="text-xs text-text-secondary" data-id="element-252">
              Entrega a tiempo
            </span>
          </div>
        </div>
      </div>
    </div>;
}